import ReactGA from 'react-ga4';
import { GA_INTERRACT_EVENTS, GA_MEDIA_EVENTS } from './constants';

export const sendMediaGAInitData = (mediaId: string, mediaTitle: string) => {
	ReactGA.event(GA_MEDIA_EVENTS.EVENT_MEDIA_LOADED, {
		position: -1,
		media_id: mediaId,
		media_title: mediaTitle,
	});
};

export const sendMediaGAPlayData = (mediaId: string, position: number | string) => {
	ReactGA.event(GA_MEDIA_EVENTS.EVENT_MEDIA_PLAYED, {
		position,
		media_id: mediaId,
	});
};

export const sendMediaGAViewData = (mediaId: string, mediaTitle: string) => {
	ReactGA.event(GA_MEDIA_EVENTS.EVENT_MEDIA_VIEWED, {
		mediaTitle,
		media_id: mediaId,
	});
};

export const sendMediaGAPauseData = (mediaId: string, position: number | string) => {
	ReactGA.event(GA_MEDIA_EVENTS.EVENT_MEDIA_PAUSED, {
		position,
		media_id: mediaId,
	});
};

export const sendMediaGACompleteData = (mediaId: string, position: number | string) => {
	ReactGA.event(GA_MEDIA_EVENTS.EVENT_MEDIA_COMPLETED, {
		position,
		media_id: mediaId,
	});
};

export const sendMediaGAHeartBeatData = (mediaId: string, position: number | string, duration: number) => {
	ReactGA.event(GA_MEDIA_EVENTS.EVENT_MEDIA_HEARTBEAT, {
		position,
		duration,
		media_id: mediaId,
	});
};

export const sendInteractGAInitData = (scene: any, interactTitle: string, interactId: string) => {
	ReactGA.event(GA_INTERRACT_EVENTS.EVENT_INTERACT_VIEWED, {
		interact_id: `${interactTitle}#${interactId}`.trim(),
		page_title: scene ? `${scene.name}#${scene.id}` : scene.id,
	});
};

export const sendInteractGADataForSceneViewed = (scene: any, interactTitle: string, interactId: string) => {
	ReactGA.event(GA_INTERRACT_EVENTS.EVENT_PAGE_VIEW, {
		page_title: scene ? `${scene.name}#${scene.id}` : scene.id,
		page_location: window.location.href,
	});
	ReactGA.event(GA_INTERRACT_EVENTS.EVENT_SCENE_VIEWED, {
		interact_id: `${interactTitle}#${interactId}`.trim(),
		scene_id: scene ? `${scene.name}#${scene.id}` : scene.id,
		page_title: scene ? `${scene.name}#${scene.id}` : scene.id,
	});
};

export const sendInteractGATrackEventData = (type: string, name: string, scenarioId: string, sceneId: string) => {
	ReactGA.event(GA_INTERRACT_EVENTS.EVENT_WIDGET_CLICKED, {
		interact_id: scenarioId,
		scene_id: sceneId,
		widget_type: type,
		widget_name: name,
		page_title: sceneId,
	});
};
